<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :label-col="labelCol1" :wrapper-col="wrapperCol1"  :rules="validatorRules" slot="detail">
          <a-row>
             <a-col :span="24">
              <a-form-model-item :label="this.language['cs.persongroup.pgroupcode']"  prop="pgroupcode">
             <a-input v-model="model.pgroupcode" :placeholder="this.language['common.autosystemcode']"  disabled></a-input>   <!-- disabled -->
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.persongroup.pgroupname']"  prop="pgroupname">
                <a-input v-model="model.pgroupname" :placeholder="this.language['cs.persongroup.pgroupname']" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['common.sort']"  prop="sort">
                <a-input-number v-model="model.sort" :placeholder="this.language['common.sort']" :min="1" :max="100"></a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.activity.activityname']"  prop="sysactivityid">
                <a-Select  v-model="model.sysactivityid" :options="selectActivityList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.activity.activityname']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </template>
  
  
  <script>
  
  import {validateDuplicateValue} from '@/utils/util'
  import { httpAction, getAction } from '@/api/manageChooseSeat'
  import moment from 'moment'
  
  export default {
    name: 'PersonGroupForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
        confirmLoading: false,
        url: {
          add: "/PersonGroup/add",
          edit: "/PersonGroup/edit"
        },
        selectActivityList:[],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
      validatorRules() {
        if (this.language) {
          return {
            
            pgroupname: [
              {required: true, message: this.language['cs.select']+this.language['cs.persongroup.pgroupname']+'!'}
            ],
            sort: [
              {required: true, message: this.language['cs.input']+this.language['common.sort']+'!'}
            ],
            sysactivityid: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.activityname']+'!'}
            ]
          }
        }
      }
  
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
     this.loadSelectData();
   
    },
    mounted(){
      },
      watch: {
    },
    methods: {
      loadSelectData() { 
          this.selectActivityList=null;  
          let selectvenue= { keytype: "activity", parentid:"",curvalue:this.model.sysactivityid};  
           getAction('/SelectData/SelectDataList', selectvenue).then((res) => {
          if (res.success) {
            this.selectActivityList= res.result.records;
          }
      });  
      },
      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
     
      submitForm() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
  
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.syspgid) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
   
    }
  }
  
  
  </script>